import { z } from 'zod'
import { BenchmarkSource } from '../utils/calculateCbamLiability'

export const cbamForecastParamsSchema = z
  .object({
    cbamBenchmark: z.number().optional(),
    customWeeklyAveragePrice: z.number().optional().nullable(),
    netMassInTonnes: z.number().optional()
  })
  .strict()

export type cbamForecastParams = z.infer<typeof cbamForecastParamsSchema>

export const calculateCBAMLiabilitySchema = z
  .object({
    weeklyAveragePrice: z.number(),
    productionMethodCode: z.string(),
    year: z.number(),
    specificDirectEmission: z.number(),
    specificIndirectEmission: z.number().nullable().optional(),
    ...cbamForecastParamsSchema.shape
  })
  .strict()

export type CalculateCBAMLiabilityPayload = z.infer<typeof calculateCBAMLiabilitySchema>

export type LiabilityBreakdown = {
  money: {
    directEmissions: number
    indirectEmissions: number
    total: number
    totalWithIndirectEmissions: number
    discount: number
  }
  tonnes: {
    directEmissions: number
    indirectEmissions: number
    total: number
    totalWithIndirectEmissions: number
    discount: number
  }
}

export type CalculateCBAMLiabilityResponse = {
  cbamBenchmark: number
  defaultCbamBenchmark: number
  productionMethodCode: string
  weeklyAveragePrice: number
  specificDirectEmission: number
  specificIndirectEmission: number
  currentYear: {
    breakdown: LiabilityBreakdown
  }
  liabilitiesPerYear: {
    [key: number]: {
      breakdown: LiabilityBreakdown
    }
  }
  benchmarkSource: BenchmarkSource
}
